import { createFileRoute } from "@tanstack/react-router";
import { useTopViewedTexts } from "../../hooks/useTopViewedTexts";
import { useTextStatistics } from "../../hooks/useTextStatistics";
import { useVocabularyStatistics } from "../../hooks/useVocabularyStatistics";
import useTranslation from "../../hooks/useTranslation";

export const Route = createFileRoute("/app/statistics")({
  component: RepriseStatisticsPage,
});

function RepriseStatisticsPage() {
  const topViewedTexts = useTopViewedTexts();
  const textStatistics = useTextStatistics();
  const vocabularyStatistics = useVocabularyStatistics();
  const { translate } = useTranslation();

  if (
    !topViewedTexts.isSuccess ||
    !textStatistics.isSuccess ||
    !vocabularyStatistics.isSuccess
  ) {
    return <div>please wait</div>;
  }

  return (
    <>
      <div className="block bg-gray-50 py-6 justify-center">
        <div className="mb-9 overflow-auto bg-white-100 px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:rounded-lg sm:px-10 w-full max-w-4xl">
          <div className="pb-6 text-xl text-left font-bold">
            <p className="text-black">
              {translate("statistics_header_vocabulary")}
            </p>
          </div>
          <div className="flex flex-wrap w-full md:justify-center gap-4">
            {[
              {
                text: translate("statistics_total_words_added"),
                value: vocabularyStatistics.data.total_created,
                css: "bg-gray-200",
              },
              {
                text: translate("statistics_total_words_added_last_seven_days"),
                value: vocabularyStatistics.data.last_week_created,
                css: "bg-white-100",
              },
              {
                text: translate("statistics_total_words_added_last_four_weeks"),
                value: vocabularyStatistics.data.last_four_weeks_created,
                css: "bg-white-100",
              },
            ].map((item, index) => {
              return (
                <div
                  key={index}
                  className={`w-full md:w-[200px] ring-1 ${item.css} flex flex-col justify-center items-center p-6 rounded-lg md:flex-1`}
                >
                  <p className="text-4xl font-bold pb-4 whitespace-nowrap text-left self-start">
                    {new Intl.NumberFormat().format(item.value)}
                  </p>
                  <p className="text-sm font-medium text-left self-start">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className=" mb-9 overflow-auto bg-white-100 px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:rounded-lg sm:px-10 w-full max-w-4xl">
          <div className="pb-6 text-xl font-bold text-left">
            <p className="text-black text-left">
              {translate("statistics_header_texts")}
            </p>
          </div>
          <div className="flex flex-wrap w-full md:justify-center gap-4">
            {[
              {
                text: translate("statistics_total_texts_created"),
                value: textStatistics.data.total_created_texts,
                css: "bg-blue-100",
              },
              {
                text: translate("statistics_total_reated_texts_last_week"),
                value: textStatistics.data.last_week_created_texts,
                css: "bg-white-100",
              },
              {
                text: translate("statistics_total_word_count"),
                value: textStatistics.data.total_created_texts_length,
                css: "bg-white-100",
              },
            ].map((item, index) => {
              return (
                <div
                  key={index}
                  className={`w-full md:w-[200px] ring-1 bg-white-100 ${item.css} flex flex-col justify-center items-center p-6 rounded-lg md:flex-1`}
                >
                  <p className="text-4xl font-bold pb-4 whitespace-nowrap text-left self-start">
                    {new Intl.NumberFormat().format(item.value)}
                  </p>
                  <p className="text-sm font-medium text-left self-start">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
